import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)


/*
 * PhotoSwipe // $ npm i photoswipe
 */
// import PhotoSwipe from 'photoswipe/dist/photoswipe.js'
// import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'

/*
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';


// Icon
// const leftArrowSVGString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 100 125" width="100" height="125"><path d="M5,50L50,5l3,3L11,50l42,42l-3,3L5,50z M92,95l3-3L53,50L95,8l-3-3L47,50L92,95z"/></svg>';
const leftArrowSVGString = '';
const closeSVGString = '';

// Padding
var padding = 60;

var windowSize = window.innerWidth;
if (windowSize < 768) {
  padding = 20;
} else {
  padding = 60;
}

// Options
const options = {
  // to apply styles just to this instance of PhotoSwipe
  mainClass: 'pswp--custom',

  gallery: '#gallery-photoswipe',
  children: 'a',
  pswpModule: PhotoSwipe,

  // Styling
  // arrowPrev: false,
  // arrowNext: false,
  zoom: false,
  // close: false,
  // counter: false

  bgOpacity: 1,
  padding: { top: padding, bottom: padding, left: padding, right: padding },

  // Icon: arrowPrevSVG, arrowNextSVG, closeSVG, zoomSVG
  arrowPrevSVG: leftArrowSVGString,
  arrowNextSVG: leftArrowSVGString,
  closeSVG: closeSVGString,

  // Transition
  showHideAnimationType: 'fade', // fade, zoom, none

  // Click actions
  imageClickAction: 'next',
  tapAction: 'next',

};

const lightbox = new PhotoSwipeLightbox(options);
lightbox.init();
*/

// Gallery is starting to close // Transition
/*
lightbox.on('close', () => {
  lastElWithBadge = lightbox.pswp.currSlide.data.element;
  if(lastElWithBadge !== firstElWithBadge) {
    // showBadge(firstElWithBadge);
    // hideBadge(lastElWithBadge);
  }
});
*/
